module.exports = __webpack_public_path__ + "static/ceo-sp-ff5111fff7f50ec329a7564ee209f168.png";